import * as common from 'store/modules/common'
import { toast } from 'react-toastify'
import { localize } from 'store/modules/localization'
import { actionTypes as dialogsActionTypes } from '../dialogs'
import { getComponentKey } from 'utils/getComponentKey'

import { api } from './api'
import { fromUtcString } from 'utils/dateUtilities'

const newEntity = {
  id: 0,
  wine: null,
  supplier: null,
  dateOfOrder: null,
  acquisitionPrice: 0,
  storagePlace: null,
  dateOfArrival: null,
  dateOfSale: null,
  actualPrice: 0,
  status: 0,
  soldByChannel: null,
  imageIds: []
}

export const prefix = 'bottles'

export { api }
export const initialState = {
  ...common.initialState,
  exporting: false,
  quickSelling: false
}
export const actionTypes = {
  ...common.actionTypes(prefix),
  exporting: `${prefix}/exporting`,
  quickSelling: `${prefix}/quickSelling`
}
export const actionCreators = {
  ...common.actionCreators(prefix, api),
  startExport: (filter = {}) => (dispatch, getState) => {

    dispatch({ type: actionTypes.exporting, payload: true })
    api.startExport(filter)
        .then(() => {
          dispatch({ type: actionTypes.exporting, payload: false })
          toast.info(localize(getState().localization, 'bottles.excelExportEnqueued'))
        })
        .catch(error => common.handleError(prefix, { getState, dispatch, error, update: { exporting: false } }))
  },
  additionalActions: {
    quickSell: (soldByChannel, bottleIds, isInDialog) => (dispatch, getState) => {
    
      dispatch({ type: actionTypes.quickSelling, payload: true })
      api.quickSell(soldByChannel, bottleIds)
        .then((response) => {
          dispatch({ type: actionTypes.quickSelling, payload: false })
          if (isInDialog) {
            dispatch({ type: dialogsActionTypes.hide })
          } else {
            dispatch({
              type: actionTypes.entity,
              payload: () => api.getEntity(bottleIds[0])
            })
          }
          toast.info(localize(getState().localization, 'bottles.bottlesSold'))
        })
        .catch(error => common.handleError(prefix, { getState, dispatch, error, update: { quickSelling: false } }))
    }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.create: return { ...state, entity: { ...newEntity, isDirty: true } }
    case actionTypes.exporting: return { ...state, exporting: action.payload }
    case actionTypes.quickSelling: return { ...state, quickSelling: action.payload, gridKey: action.payload ? state.gridKey : getComponentKey() }

    default: return common.reducer(state, action, prefix, {
      transformPayload: payload => ({
        ...payload,
        dateOfOrder: fromUtcString(payload.dateOfOrder),
        dateOfArrival: fromUtcString(payload.dateOfArrival),
        dateOfSale: fromUtcString(payload.dateOfSale)
    })})
  }
}

